import { doc, getDoc } from "firebase/firestore";
import React, { createContext, useContext, useEffect, useState } from "react";
import { db } from "../utils/firebase";

import { toast } from "react-toastify";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);



  // 🔐 Login
  const login = async (email, password, navigate) => {
  try {
    const response = await fetch(
      "https://us-central1-zafflostarter.cloudfunctions.net/loginUser",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      }
    );

    const result = await response.json();

    if (!response.ok) {
      toast.error(result.error || "Invalid credentials");
      return;
    }

    const userDocRef = doc(db, "userDetails", email);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) {
      toast.error("User data not found.");
      return;
    }

    const userData = userDoc.data();
    const businessSubType = userData.businessSubType || null;
    const businessName = userData.businessName || null;


    const { role } = result;

    const loggedInUser = { email, role };
    setUser(loggedInUser);

    localStorage.setItem("user", email);
    localStorage.setItem("role", role);
    localStorage.setItem("businessSubType", businessSubType || "");
    localStorage.setItem("businessName", businessName || "");

    if (role === "admin") navigate("/admin");
    else if (role === "employee") navigate("/employee");
    else navigate("/user");
  } catch (error) {
    console.error("Login Error:", error);
    toast.error("Unable to login. Please try again.");
  }
};


  // ✅ Verify user securely on refresh
  useEffect(() => {
    const checkUser = async () => {
      const savedUser = localStorage.getItem("user");
      const savedRole = localStorage.getItem("role");

      if (savedUser && savedRole) {
        try {
          const userDocRef = doc(db, "userDetails", savedUser);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            const businessSubType = userData.businessSubType || null;
            const businessName = userData.businessName || null;

            // Force Firestore role (ignore tampered localStorage role)
            setUser({ email: savedUser, role: userData.role, businessSubType, });

            // Update localStorage with the correct role
            localStorage.setItem("role", userData.role);
            localStorage.setItem("businessSubType", businessSubType || "");
            localStorage.setItem("businessName", businessName || "");
          } else {
            // User not found in Firestore → clear
            setUser(null);
            localStorage.removeItem("user");
            localStorage.removeItem("role");
          }
        } catch (err) {
          console.error("Error verifying user role:", err);
          setUser(null);
          localStorage.removeItem("user");
          localStorage.removeItem("role");
        }
      }
      setLoading(false);
    };

    checkUser();
  }, []);

  // 🚪 Logout
  const logout = (navigate) => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("role");
    localStorage.removeItem("businessSubType");
    localStorage.removeItem("businessName");
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
